import cookies from 'js-cookie'
import { SDK_PRODUCT } from '@/config/dataMap.js'

const LoginStatusKey = 'LS' // Login-Status登录态 0 1
const TokenKey = 'AT' // Access-Token
const UserInfoKey = 'UI' // User-Info用户信息 {}
const PermissionInfoKey = 'PMI' // Permission
const PermissionVipInfoKey = 'PMVI' // PermissionVipInfo
const RecentLoginListKey = `recent_login_ist_${SDK_PRODUCT.id}` // 最近登录的列表
const UnionLoginList = 'union_login_ist' // 客户端写入的联合会员列表-数组
const DubaLoginInfo = 'duba_login_info' // 客户端写入的毒霸会员信息-对象
const ProductLoginList = 'product_login_list' // 客户端写入的当前产品的历史登陆信息-数组

export function loadLoginStatus () {
  return Number(cookies.get(LoginStatusKey)) || 0
}

// 如果是0则用户退出登录，清除cookie
export function saveLoginStatus (status) {
  if (status == 0) {
    cookies.remove(LoginStatusKey)
  } else {
    cookies.set(LoginStatusKey, status, { expires: 365 })
  }
  return status
}

export function loadToken () {
  return cookies.get(TokenKey)
}

export function saveToken (token) {
  cookies.set(TokenKey, token, { expires: 50 })
  return token
}

export function removeToken () {
  cookies.remove(TokenKey)
  return ''
}

export function loadUserInfo () {
  try {
    return cookies.get(UserInfoKey) && JSON.parse(cookies.get(UserInfoKey))
  } catch (error) {
    console.log(' -- userInfo parse failure -- ')
  }
}

export function saveUserInfo (userInfo) {
  cookies.set(UserInfoKey, JSON.stringify(userInfo), { expires: 365 })
  return userInfo
}

export function removeUserInfo () {
  cookies.remove(UserInfoKey)
  return {}
}

export function loadPermissionInfo () {
  return cookies.get(PermissionInfoKey) && JSON.parse(cookies.get(PermissionInfoKey))
}

export function savePermissionInfo (pm) {
  cookies.set(PermissionInfoKey, JSON.stringify(pm), { expires: 365 })
  return pm
}

export function loadPermissionVipInfo () {
  return cookies.get(PermissionVipInfoKey) && JSON.parse(cookies.get(PermissionVipInfoKey))
}

export function savePermissionVipInfo (pm) {
  cookies.set(PermissionVipInfoKey, JSON.stringify(pm), { expires: 365 })
  return pm
}

// 获取最近的登录历史
export function getRecentLoginList () {
  let list = cookies.get(RecentLoginListKey) || []
  try {
    list = JSON.parse(cookies.get(RecentLoginListKey))
  } catch (e) {
    console.log('获取最近的登录历史: json解析失败, ', e)
    list = []
  }
  return list
}

// 获取客户端写入的联合会员列表
export function getUnionLoginList () {
  let list = cookies.get(UnionLoginList)
  try {
    if (list) {
      list = JSON.parse(list)
    }
    list = list || []
    list.forEach((item, index) => {
      list[index] = JSON.parse(item)
    })
    return list
  } catch (e) {
    console.log('UnionLoginList转换json失败')
    return []
  }
}

// 获取客户端写入的毒霸账号信息
export function getDubaLoginList () {
  let info = cookies.get(DubaLoginInfo)
  try {
    if (info) {
      info = JSON.parse(info)
    }
    return info ? [info] : []
  } catch (e) {
    console.log('DubaLoginInfo转换json失败')
    return []
  }
}

// 获取客户端写入的当前产品的列表
export function getProductLoginList () {
  let list = cookies.get(ProductLoginList)
  try {
    if (list) {
      list = JSON.parse(list)
    }
    list = list || []
    list.forEach((item, index) => {
      list[index] = JSON.parse(item)
    })
    return list
  } catch (e) {
    console.log('DubaLoginInfo转换json失败')
    return []
  }
}

function isVip (userInfo) {
  return userInfo && userInfo.vip_type && userInfo.vip_type != '0'
}

/* eslint-disable-next-line */
export function addRecentLoginList (userInfo, token) {
  const list = getRecentLoginList()
  if (userInfo && token) {
    userInfo.token = token
    if (isVip(userInfo)) {
      userInfo.is_vip = 1
    }

    let vipIndex = -1
    // 删除相同的账号 & 找到最后一个会员的位置
    list.forEach((item, index) => {
      if (isVip(item)) {
        vipIndex = index
      }
      if (item.open_id === userInfo.open_id) {
        list.splice(index, 1)
      }
    })

    // 最大支持同时保存3个账号。
    // 会员账号登录态高优先级
    // 普通账号登录态保留，按最近退出登录时间，依次保留登录态

    // 判断是否是会员
    if (userInfo.is_vip) {
      list.unshift(userInfo)
    } else {
      vipIndex = vipIndex + 1 >= 2 ? 2 : vipIndex + 1
      list.splice(vipIndex, 0, userInfo)
    }

    saveRecentLoginList(list.slice(0, 3))
  }
}

export function removeRecentLoginList (index) {
  const list = getRecentLoginList()
  if (list) {
    list.splice(index, 1)
    saveRecentLoginList(list)
  }
}

export function saveRecentLoginList (list) {
  cookies.set(RecentLoginListKey, list, { expires: 365 })
}
